//angular references
import { Component, NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClientModule  } from '@angular/common/http';
import { RouterModule } from '@angular/router';

//bootstrap references
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

//components
import { AppComponent } from './components/app/app.component';
import { NavBarComponent } from './components/navbar/navbar.component';
import { BEItineraryComponent } from './components/beItinerary/beItinerary.component';
import { BEVehicleSelectionComponent } from './components/beVehicleSelection/beVehicleSelection.component';
import { BEExtrasComponent } from './components/beExtras/beExtras.component';
import { BEReviewComponent } from './components/beReview/beReview.component';
import { BEConfirmationComponent } from './components/beConfirmation/beConfirmation.component';

//services
import { BEDataService } from './services/businessEvent/beData.service';
import { BEWorkflowService } from './services/businessEvent/beWorkflow.service';
import { BEWorkflowGuard } from './services/businessEvent/beWorkflow-guard.service';
import { ConfigDataService } from './services/configuration/configData.service';
import { CachedDataService } from './services/dataCache/cachedData.service';
import { DictionaryService } from './services/dictionary/dictionary.service';

//primeng references
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { GMapModule } from 'primeng/gmap';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';

import { CalendarModule, Calendar } from 'primeng/calendar';

//google references
import { } from 'googlemaps';

@NgModule({
    declarations: [
        AppComponent,
        NavBarComponent,
        BEItineraryComponent,
        BEVehicleSelectionComponent,
        BEExtrasComponent,
        BEReviewComponent,
        BEConfirmationComponent,
    ],
    entryComponents: [
    ],
    providers: [
        { provide: DictionaryService, useClass: DictionaryService },
        { provide: ConfigDataService, useClass: ConfigDataService },
        { provide: CachedDataService, useClass: CachedDataService },
        { provide: BEDataService, useClass: BEDataService },
        { provide: BEWorkflowService, useClass: BEWorkflowService },
        BEWorkflowGuard,
        ConfirmationService
    ],
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,

        ConfirmDialogModule,
        DropdownModule,
        GMapModule,
        DialogModule,
        CheckboxModule,
        ButtonModule,
        CalendarModule,

        NgbModule.forRoot(), 
        RouterModule.forRoot([
            { path: '', redirectTo: 'beItinerary', pathMatch: 'full' },
            { path: 'beItinerary', component: BEItineraryComponent, canActivate: [BEWorkflowGuard] },
            { path: 'beVehicleSelection', component: BEVehicleSelectionComponent, canActivate: [BEWorkflowGuard]  },
            { path: 'beExtras', component: BEExtrasComponent, canActivate: [BEWorkflowGuard]  },
            { path: 'beReview', component: BEReviewComponent, canActivate: [BEWorkflowGuard]  },
            { path: 'beConfirmation', component: BEConfirmationComponent, canActivate: [BEWorkflowGuard]  },
            { path: '**', redirectTo: 'beItinerary' }
        ])
    ]
})

export class AppModuleShared {
}
